"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _mergeRefs = _interopRequireDefault(require("./mergeRefs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-next-line react-hooks/exhaustive-deps
var useForkRef = function useForkRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return (0, _react.useMemo)(function () {
    return _mergeRefs["default"].apply(void 0, refs);
  }, refs);
};

var _default = useForkRef;
exports["default"] = _default;